import defaultProps from './defaultProps';
import mock from './mock';
import propTypes from './propTypes';

const Checkbox = {
	DefaultProps: defaultProps,
	Mock: mock,
	PropTypes: propTypes,
};

export default Checkbox;
